import _ from 'lodash';
import Injector from 'vue-inject';
import Debug from '@/util/debug';
import { can } from '@/util/permissions';

const debug = Debug('service:Step');

export const STEP_TARGET = 'campaign-target';
export const STEP_OFFER = 'campaign-offer';
export const STEP_FORMAT = 'campaign-format';
export const STEP_SETTINGS = 'campaign-settings';
export const STEP_CHECKOUT = 'campaign-checkout';
export const STEP_PROPOSAL = 'proposal';

export default class StepService {
  constructor() {
    // TODO Add Checkout step handling
    this.steps = [
      {
        id: 1,
        route: STEP_TARGET,
        show: false,
      },
      {
        id: 2,
        route: STEP_OFFER,
        show: true,
      },
      {
        id: 3,
        route: STEP_FORMAT,
        show: true,
      },
      {
        id: 4,
        route: STEP_SETTINGS,
        show: true,
      },
      {
        id: 5,
        route: STEP_CHECKOUT,
        show: true,
      },
    ];
    this.firstStep = this.steps[0].route;
    this.lastStep = this.steps[this.steps.length - 1].route;
  }

  getSteps() {
    debug.info('getSteps', this.steps);

    return new Promise(resolve => resolve(this.steps));
  }

  isStepAvailable(campaign, routeName) {
    const steps = this.getAvailableSteps(campaign);
    if (steps.length === 0 || steps.indexOf(routeName) === -1) {
      return false;
    }
    return true;
  }

  getAvailableSteps(campaign) {
    let availableSteps = [];
    let stepFound = false;

    this.steps.every(step => {
      const stepName = step.route;
      availableSteps.push(stepName);
      if (stepFound) {
        return false;
      }

      if (stepName === campaign.currentStep) {
        stepFound = true;
      }
      return true;
    });

    if (stepFound === false) {
      availableSteps = [this.firstStep];
    } else if (campaign.currentStep === this.lastStep) {
      availableSteps = [];
      const famCampaign = _.get(campaign, 'famCampaign', null);
      if (can(famCampaign, ['changeTarget'])) {
        availableSteps.push(STEP_TARGET);
      }
      availableSteps.push(STEP_PROPOSAL); // Redirect to proposal page
    }

    return availableSteps;
  }

  getNextStep(route) {
    const currentStep = this.steps.findIndex(s => s.route === route);
    if (currentStep === -1 || currentStep === this.steps.length - 1) {
      return null;
    }

    return this.steps[currentStep + 1];
  }
}

Injector.service('stepService', [], StepService);



// WEBPACK FOOTER //
// ./src/services/StepService.js